export default __webpack_public_path__ + "static/media/IconDesc_Fuel.256.56606534.png";